import { jsxs, jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Counter.css';/* empty css             */
const Counter = ({ count, prefix, postfix }) => {
  if (typeof count === "undefined") {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-counter"), children: [
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-counter__prefix"), children: prefix }),
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-counter__count"), children: count }),
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-counter__postfix"), children: postfix })
  ] });
};
export {
  Counter as default
};
//# sourceMappingURL=Counter.js.map
